import _extends from "@babel/runtime-corejs3/helpers/extends";import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";var _excluded = ["width", "autocompletePattern", "minAge", "maxAge", "value", "validationMessage", "validationPassed", "currentDate"];import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/slice";import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";import React from 'react';

import { InputText } from "../..";
import { INPUT_OPTIONS_SIZES } from "../../../utils/forms";
import { createStyles } from "./styles";

var DateOfBirthOption = function DateOfBirthOption(_ref)









{var _context, _context2;var _ref$width = _ref.width,width = _ref$width === void 0 ? 'large' : _ref$width,autocompletePattern = _ref.autocompletePattern,_ref$minAge = _ref.minAge,minAge = _ref$minAge === void 0 ? 0 : _ref$minAge,_ref$maxAge = _ref.maxAge,maxAge = _ref$maxAge === void 0 ? 120 : _ref$maxAge,_ref$value = _ref.value,value = _ref$value === void 0 ? '' : _ref$value,validationMessage = _ref.validationMessage,_ref$validationPassed = _ref.validationPassed,validationPassed = _ref$validationPassed === void 0 ? true : _ref$validationPassed,_ref$currentDate = _ref.currentDate,currentDate = _ref$currentDate === void 0 ? '' : _ref$currentDate,props = _objectWithoutProperties(_ref, _excluded);
  var classes = createStyles();
  var currentISODate = currentDate || _sliceInstanceProperty(_context = new Date().toISOString()).call(_context, 0, 10);

  var customerAge = new Date().getFullYear() - new Date(value).getFullYear();
  var isDobTouched = value.length > 0;
  var isDateInFuture = new Date().getTime() - new Date(value).getTime() < 0;

  var isDobValid = isDobTouched ?
  customerAge >= minAge && customerAge <= maxAge && !isDateInFuture :
  validationPassed;

  return /*#__PURE__*/(
    React.createElement(InputText, _extends({},
    props, {
      value: value,
      htmlType: "date",
      width: INPUT_OPTIONS_SIZES[width] || width,
      currentDate: currentISODate,
      validationPassed: isDobTouched ? isDobValid : validationPassed,
      validationMessage:
      isDobTouched ? _concatInstanceProperty(_context2 = "Age must be more than ".concat(minAge, " and less than ")).call(_context2, maxAge) : validationMessage,

      description:
      autocompletePattern && /*#__PURE__*/React.createElement("span", { className: classes.description }, autocompletePattern) })));



};

export default DateOfBirthOption;
//# sourceMappingURL=index.js.map